import { IoMdAdd } from 'react-icons/io'
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogTitle,
  DialogTrigger,
  useToast,
} from 'ui'
import { useMessageTemplateCreate } from '../hooks/useMessageTemplateCreate'
import { IMessageTemplate } from '../providers/MessageTemplate.provider'
import { MessageTemplateEditorV2 } from './MessageTemplateEditorV2'
import { TranslatorOnlyString } from './Translator'

export const CreateMessageTemplateV2 = (props: {
  channel: IMessageTemplate['channel']
  btnLabel?: string
}) => {
  const {
    btnLabel,
    createMessageTemplate,
    formId,
    isLoading,
    onCreateMessageTemplate,
    setIsLoading,
    setCreateMessageTemplate,
  } = useMessageTemplateCreate(props)

  const { toast } = useToast()

  return (
    <>
      <Button
        className='mt-3'
        onClick={() => setCreateMessageTemplate(props.channel)}
        size='sm'
      >
        <IoMdAdd className='mr-2' />
        {btnLabel}
      </Button>

      <Dialog
        onOpenChange={(open) => {
          if (!open) {
            setCreateMessageTemplate(undefined)
          }
        }}
        open={!!createMessageTemplate}
      >
        <DialogContent
          overlayClassName='flex items-center justify-center'
          className='max-w-6xl w-full'
        >
          <DialogHeader>
            <DialogTitle>
              Crear plantilla para{' '}
              {TranslatorOnlyString({ children: createMessageTemplate })}
            </DialogTitle>
          </DialogHeader>
          <MessageTemplateEditorV2
            onSubmit={(data) =>
              onCreateMessageTemplate(data, () => {
                toast({
                  description: 'Plantilla de mensaje creada',
                  variant: 'success',
                })
              })
            }
            formId={formId}
            channel={createMessageTemplate}
          />
          <DialogFooter>
            <Button
              type='submit'
              disabled={isLoading}
              loading={isLoading}
              form={formId}
              className='mr-3'
            >
              Crear
            </Button>
            <Button
              disabled={isLoading}
              onClick={() => setCreateMessageTemplate(undefined)}
              variant='ghost'
            >
              Cancelar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
